import { useSelector } from 'react-redux';
import { userService } from '../../Services/userService';

export const SignOut = () => {
    const settings = useSelector((state: any) => state.settings);
    const signOut = () => {
        userService.logout().then(() => {
            localStorage.removeItem('loginProvider');
            document.location.href = settings.oidcLogoutUrl + document.location.href;
        });
    };

    return signOut;
};
